import React from 'react';
import { OFICINAS } from '../../data/constants';
import { waLink } from '../../utils/whatsapp';
import { MapPinIcon, ClockIcon, PhoneIcon } from '../Icons';
import './Oficinas.css';

const Oficinas: React.FC = () => (
  <section id="oficinas" style={{ background: 'var(--dark-2)' }}>
    <div className="section-label">Ubicaciones</div>
    <h2 className="section-title">Nuestras <em>oficinas</em></h2>
    <div className="divider" />

    <div className="oficinas-grid">
      {OFICINAS.map((o) => (
        <div className="oficina-card" key={o.name}>
          <div>
            <div className="oficina-badge">
              <MapPinIcon size={10} /> {o.badge}
            </div>
          </div>
          <div className="oficina-name">{o.name}</div>
          <div className="oficina-detail">
            <MapPinIcon size={14} />
            <span>{o.address}</span>
          </div>
          <div className="oficina-detail">
            <ClockIcon size={14} />
            <span>{o.hours}</span>
          </div>
          <div className="oficina-detail">
            <PhoneIcon size={14} />
            <a href={`tel:${o.phone.replace(/[^\d+]/g, '')}`} className="oficina-tel">{o.phone}</a>
          </div>
          <a
            href={waLink(`Hola, quisiera contactarme con la oficina de ${o.name}.`)}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost"
            style={{ fontSize: '0.68rem', width: 'fit-content' }}
          >
            Contactar →
          </a>
        </div>
      ))}
    </div>
  </section>
);

export default Oficinas;
